"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: 'create'
    },
    saveItem: {
      type: Function,
      default: function _default() {}
    },
    clearForm: {
      type: Function,
      default: function _default() {}
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isOnlyConfirm: {
      type: Boolean,
      default: false
    },
    array: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initHeight: {
      type: String,
      default: function _default() {
        return '400px';
      }
    }
  },
  data: function data() {
    return {
      styleObject: {}
      // isVisible: false
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    }
  })), {}, {
    isVisible: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    }
  }),
  mounted: function mounted() {},
  methods: {
    clickCloseBtn: function clickCloseBtn(done) {
      var _this = this;
      if (this.isOnlyConfirm) {
        this.isVisible = false;
        return;
      }
      // console.log('close------', this.form.values[1].state, this.initForm.values[1].state)
      var isSame = (0, _index.compareObject)(this.form, this.initForm);
      var isSame1 = (0, _index.compareArray)(this.array, this.initArray);
      // console.log('isSame--isSame1-------', isSame, isSame1)

      if (isSame && isSame1) {
        this.isVisible = false;
      } else {
        this.$confirm(this.$t('common.confirm11')).then(function (_) {
          _this.isVisible = false;
          // done()
          _this.clearForm();
        }).catch(function (_) {});
      }
    },
    clickCancel: function clickCancel() {
      this.isVisible = false;
      this.clearForm();
    },
    clickSave: function clickSave() {
      this.saveItem();
    },
    closeFunc: function closeFunc() {}
  }
};